import React, { useState, useEffect } from 'react';
import Layout2 from '../../components/global/layout2';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import environment from '../../environment';
import { toast } from 'react-toastify';

const AdminDocuments = () => {
  const [loads, setLoads] = useState([]);
  const [selectedLoad, setSelectedLoad] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [docsLoading, setDocsLoading] = useState(false);
  const [typeFilter, setTypeFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const docTypes = ['BOL', 'POD', 'Rate Confirmation', 'Insurance Certificate', 'Carrier Packet', 'W9', 'Lumper Receipt', 'Scale Ticket', 'Other'];

  const statusBadge = {
    pending: { bg: '#fff3cd', color: '#856404' },
    verified: { bg: '#d4edda', color: '#155724' },
    rejected: { bg: '#f8d7da', color: '#721c24' }
  };

  // Fetch loads that potentially have documents
  const fetchLoads = () => {
    setLoading(true);
    const params = {
      page,
      count: 20,
      search: searchTerm,
      isDeleted: false
    };

    ApiClient.get('admin/filter-loads', params).then(res => {
      if (res && res.success) {
        setLoads(res.data && res.data.data ? res.data.data : (res.data || []));
        setTotal(res.data && res.data.total ? res.data.total : 0);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchLoads();
  }, [page, searchTerm]);

  const fetchLoadDocuments = (loadId) => {
    setDocsLoading(true);
    setSelectedLoad(loadId);
    ApiClient.get('load/' + loadId + '/documents').then(res => {
      if (res && res.success) {
        setDocuments(res.data || []);
      }
      setDocsLoading(false);
    }).catch(() => setDocsLoading(false));
  };

  const handleVerify = (loadId, docId, status) => {
    loader(true);
    ApiClient.put('load/' + loadId + '/documents/' + docId + '/verify', { status: status }).then(res => {
      if (res && res.success) {
        toast.success('Document ' + status + ' successfully');
        fetchLoadDocuments(loadId);
      } else {
        toast.error((res && res.message) || 'Action failed');
      }
      loader(false);
    }).catch(() => {
      loader(false);
      toast.error('Action failed');
    });
  };

  const getDocIcon = (url) => {
    if (!url) return 'fa-file';
    var lower = url.toLowerCase();
    if (lower.includes('.pdf')) return 'fa-file-pdf-o';
    if (lower.includes('.png') || lower.includes('.jpg') || lower.includes('.jpeg')) return 'fa-file-image-o';
    if (lower.includes('.doc')) return 'fa-file-word-o';
    return 'fa-file';
  };

  const filteredDocs = documents.filter(function (d) {
    if (typeFilter && d.type !== typeFilter) return false;
    if (statusFilter && d.status !== statusFilter) return false;
    return true;
  });

  return (
    <Layout2 title="Document Management">
      <div className="mainareas">
        <div className="edit-page-common edit-page-commons">
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
            <h3 className="ViewUser mb-0">
              <i className="fa fa-folder-open me-2"></i>
              Document Management
            </h3>
          </div>

          <div className="row">
            {/* Left Panel - Loads List */}
            <div className="col-md-4">
              <div className="white-bg-main" style={{ padding: '12px', minHeight: 500 }}>
                <div className="white-head mb-3">
                  <h5 className="profilelist">Loads</h5>
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search by load #..."
                    value={searchTerm}
                    onChange={function (e) { setSearchTerm(e.target.value); setPage(1); }}
                  />
                </div>

                {loading ? (
                  <div className="text-center py-4">
                    <i className="fa fa-spinner fa-spin"></i>
                  </div>
                ) : loads.length === 0 ? (
                  <p className="text-center text-muted">No loads found</p>
                ) : (
                  <div style={{ maxHeight: 420, overflowY: 'auto' }}>
                    {loads.map(function (load, i) {
                      var docCount = (load.documents ? load.documents.length : 0)
                        + (load.pod_doc ? load.pod_doc.length : 0)
                        + (load.bol_doc ? load.bol_doc.length : 0);
                      return (
                        <div
                          key={load.id || load._id || i}
                          onClick={function () { fetchLoadDocuments(load.id || load._id); }}
                          style={{
                            padding: '10px 12px',
                            borderBottom: '1px solid #eee',
                            cursor: 'pointer',
                            background: selectedLoad === (load.id || load._id) ? '#eaf2f8' : 'transparent',
                            borderLeft: selectedLoad === (load.id || load._id) ? '3px solid #3E549D' : '3px solid transparent',
                            transition: 'all 0.15s'
                          }}
                        >
                          <div style={{ fontWeight: 600, fontSize: 13 }}>
                            Load #{load.load_id || 'N/A'}
                          </div>
                          <div style={{ fontSize: 11, color: '#7f8c8d' }}>
                            {load.origin_address ? load.origin_address.substring(0, 25) : 'N/A'} &rarr; {load.destination_address ? load.destination_address.substring(0, 25) : 'N/A'}
                          </div>
                          <div style={{ fontSize: 11, marginTop: 2 }}>
                            <span style={{
                              background: load.shipment_status === 'delivered' ? '#d4edda' : '#fff3cd',
                              color: load.shipment_status === 'delivered' ? '#155724' : '#856404',
                              padding: '1px 6px',
                              borderRadius: 3,
                              fontSize: 10,
                              fontWeight: 600
                            }}>
                              {load.shipment_status || 'active'}
                            </span>
                            {docCount > 0 && (
                              <span style={{ marginLeft: 6, color: '#3E549D', fontWeight: 600, fontSize: 10 }}>
                                <i className="fa fa-file-o me-1"></i>{docCount} docs
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-2" style={{ fontSize: 12 }}>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={page <= 1}
                    onClick={function () { setPage(function (p) { return Math.max(1, p - 1); }); }}
                  >
                    &larr; Prev
                  </button>
                  <span>Page {page}</span>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={loads.length < 20}
                    onClick={function () { setPage(function (p) { return p + 1; }); }}
                  >
                    Next &rarr;
                  </button>
                </div>
              </div>
            </div>

            {/* Right Panel - Documents */}
            <div className="col-md-8">
              <div className="white-bg-main" style={{ padding: '12px', minHeight: 500 }}>
                <div className="white-head mb-3 d-flex justify-content-between align-items-center">
                  <h5 className="profilelist">
                    {selectedLoad ? 'Documents' : 'Select a Load'}
                  </h5>
                  {selectedLoad && (
                    <div className="d-flex gap-2">
                      <select
                        className="form-control form-control-sm"
                        style={{ width: 'auto', fontSize: 12 }}
                        value={typeFilter}
                        onChange={function (e) { setTypeFilter(e.target.value); }}
                      >
                        <option value="">All Types</option>
                        {docTypes.map(function (t) { return <option key={t} value={t}>{t}</option>; })}
                      </select>
                      <select
                        className="form-control form-control-sm"
                        style={{ width: 'auto', fontSize: 12 }}
                        value={statusFilter}
                        onChange={function (e) { setStatusFilter(e.target.value); }}
                      >
                        <option value="">All Status</option>
                        <option value="pending">Pending</option>
                        <option value="verified">Verified</option>
                        <option value="rejected">Rejected</option>
                      </select>
                    </div>
                  )}
                </div>

                {!selectedLoad ? (
                  <div className="text-center py-5" style={{ color: '#bbb' }}>
                    <i className="fa fa-hand-pointer-o fa-3x mb-3" style={{ display: 'block' }}></i>
                    <p>Select a load from the left to view its documents</p>
                  </div>
                ) : docsLoading ? (
                  <div className="text-center py-5">
                    <i className="fa fa-spinner fa-spin fa-2x"></i>
                  </div>
                ) : filteredDocs.length === 0 ? (
                  <div className="text-center py-5" style={{ color: '#bbb' }}>
                    <i className="fa fa-file-o fa-3x mb-3" style={{ display: 'block' }}></i>
                    <p>No documents found for this load</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-sm table-hover" style={{ fontSize: 13 }}>
                      <thead>
                        <tr style={{ background: '#f8f9fa' }}>
                          <th>Type</th>
                          <th>File</th>
                          <th>Uploaded By</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredDocs.map(function (doc, i) {
                          var st = statusBadge[doc.status] || statusBadge.pending;
                          return (
                            <tr key={doc.id || doc._id || i}>
                              <td>
                                <span style={{
                                  background: '#eaf2f8',
                                  color: '#3E549D',
                                  padding: '2px 8px',
                                  borderRadius: 4,
                                  fontSize: 11,
                                  fontWeight: 600
                                }}>{doc.type}</span>
                              </td>
                              <td>
                                <i className={'fa ' + getDocIcon(doc.url) + ' me-1'}></i>
                                {(doc.filename || doc.url || 'Document').substring(0, 30)}
                              </td>
                              <td style={{ color: '#555' }}>{doc.uploaded_by_name || 'System'}</td>
                              <td style={{ color: '#7f8c8d' }}>
                                {doc.uploaded_at ? new Date(doc.uploaded_at).toLocaleDateString() : 'N/A'}
                              </td>
                              <td>
                                <span style={{
                                  background: st.bg,
                                  color: st.color,
                                  padding: '2px 8px',
                                  borderRadius: 4,
                                  fontSize: 11,
                                  fontWeight: 600
                                }}>{doc.status || 'pending'}</span>
                              </td>
                              <td>
                                <a
                                  href={environment.api + 'documents/' + doc.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm btn-outline-primary me-1"
                                  style={{ padding: '1px 6px', fontSize: 11 }}
                                >
                                  <i className="fa fa-eye"></i>
                                </a>
                                {doc.status === 'pending' && (
                                  <>
                                    <button
                                      className="btn btn-sm btn-outline-success me-1"
                                      style={{ padding: '1px 6px', fontSize: 11 }}
                                      onClick={function () { handleVerify(selectedLoad, doc.id || doc._id, 'verified'); }}
                                    >
                                      <i className="fa fa-check"></i> Verify
                                    </button>
                                    <button
                                      className="btn btn-sm btn-outline-danger"
                                      style={{ padding: '1px 6px', fontSize: 11 }}
                                      onClick={function () { handleVerify(selectedLoad, doc.id || doc._id, 'rejected'); }}
                                    >
                                      <i className="fa fa-times"></i> Reject
                                    </button>
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout2>
  );
};

export default AdminDocuments;
